export default __webpack_public_path__ + "static/media/public-holidays-modal.45909dc7.svg";